var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9811 10.3504L14.5979 7.73352C15.0535 7.27798 15.7921 7.27798 16.2476 7.73352C16.7031 8.18907 16.7031 8.92765 16.2476 9.38319L13.6308 12L16.2476 14.6169C16.7031 15.0724 16.7031 15.811 16.2476 16.2665C15.7921 16.7221 15.0535 16.7221 14.5979 16.2665L11.9811 13.6497L9.36427 16.2665C8.90873 16.7221 8.17015 16.7221 7.7146 16.2665C7.25906 15.811 7.25906 15.0724 7.7146 14.6169L10.3314 12L7.7146 9.38319C7.25906 8.92765 7.25906 8.18907 7.7146 7.73352C8.17015 7.27798 8.90873 7.27798 9.36427 7.73352L11.9811 10.3504Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9811 23.6667C18.4244 23.6667 23.6478 18.4434 23.6478 12C23.6478 5.55672 18.4244 0.333374 11.9811 0.333374C5.5378 0.333374 0.314453 5.55672 0.314453 12C0.314453 18.4434 5.5378 23.6667 11.9811 23.6667ZM11.9811 21.3334C17.1358 21.3334 21.3145 17.1547 21.3145 12C21.3145 6.84538 17.1358 2.66671 11.9811 2.66671C6.82646 2.66671 2.64779 6.84538 2.64779 12C2.64779 17.1547 6.82646 21.3334 11.9811 21.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOutline);
export default __webpack_public_path__ + "static/media/cancel-outline.5690755b1ddc443806960a7ca1063a8c.svg";
export { ForwardRef as ReactComponent };